<template>
  <div>
    <section class="section">
      <div class="container">

        
        <div class="columns is-centered">
          <div class="column is-8-desktop is-10">
            
            <div class="">
                <div class="field has-addons">
                    <p class="control is-expanded">
                        <input v-model="searchTerm" @keyup.enter="load" class="input" type="text" placeholder="Search for survey">
                    </p>
                    <p class="control">
                        <a class="button is-primary" @click.prevent="load">
                            Search
                        </a>
                    </p>
                </div>

            </div>
            <div class="mt-6 is-flex is-justify-content-flex-end">
              <span v-bind:class="{'has-text-primary': viewMode==0}" class="icon is-small is-clickable mx-1" @click="viewMode =0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-list"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>
              </span>
              <span v-bind:class="{'has-text-primary': viewMode==1}" class="icon is-small is-clickable mx-1" @click="viewMode =1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-table"><path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"></path></svg>
              </span>
            </div>
            <div class="mt-3 is-flex is-justify-content-flex-end">
              <div class="field is-horizontal is-align-items-center">
                <label class="label mb-0 mr-3" for="sortResult"
                  >Sort By</label
                >
                <div class="control">
                      <div class="select is-small">
                        <select @change="sortResultSelect($event)" name="sortResult">
                          <option value="date">Date</option>
                          <option value="total">Total</option>
                          <option value="upvotes">Up Votes</option>
                          <option value="okvotes">Ok Votes</option>
                          <option value="downvotes">Down Votes</option>
                          <option value="option4votes">4th Option Votes</option>
                          <option value="option5votes">5th Option Votes</option>
                        </select>
                      </div>
                </div>
              </div>
            </div>
            <div v-bind:class="{'is-active': isLoading}" class="loader-wrapper">
                <div class="loader is-loading"></div>
            </div>

            <div v-if="!isLoading && feedbackForms.length ==0" class="has-text-centered">
              No surveys, polls or web ratings found.
            </div>

<div v-if="viewMode==1" class="table-container">
<table  class="table is-fullwidth is-striped  mt-3">
  <tbody>
    <tr v-for="(ff, index) in feedbackForms" v-bind:key="index">
      <td class="is-vcentered"><router-link
                  :to="{ name: 'FeedbackView', params: { formId: ff.id  }}"
                >{{ff.name}}</router-link>
      </td>
      <td class="has-text-centered no-wrap">
        <div class="is-size-6 has-text-grey-light	">Total</div>
        <div class="title is-4 has-text-grey">{{ff.votesTotal}}</div>
      </td>
      <td class="has-text-centered no-wrap">
                            <p class="is-size-6">{{ff.up_label}}</p>
                    <p class="title is-4 thumbup">{{ff.votesUp}}</p>
      </td>
      <td class="has-text-centered no-wrap">
        <p class="is-size-6">{{ff.ok_label}}</p>
                    <p class="title is-4 thumbok">{{ff.votesOk}}</p>
      </td>
      <td class="has-text-centered">
                          <p class="is-size-6">{{ff.down_label}}</p>
                    <p class="title is-4 thumbdown">{{ff.votesDown}}</p>
      </td>
      <td class="has-text-centered no-wrap">
        <div v-if="ff.option4_label">
          <p class="is-size-6">{{ff.option4_label}}</p>
                    <p class="title is-4 thumboption4">{{ff.votesOption4}}</p>
        </div>
      </td>
      <td class="has-text-centered no-wrap">
        <div v-if="ff.option5_label">
                    <p class="is-size-6">{{ff.option5_label}}</p>
                    <p class="title is-4 thumboption5">{{ff.votesOption5}}</p>
        </div>
      </td>
    </tr>
  </tbody>
</table>
</div>

            <div v-else v-for="(ff, index) in feedbackForms" v-bind:key="index" class="card mt-3 is-list">
                <header class="card-header">
    <p class="card-header-title">
      <router-link
                  :to="{ name: 'FeedbackView', params: { formId: ff.id  }}"
                >{{ff.name}} ({{ff.votesTotal}})</router-link> 
    </p>
                </header>

<div class="card-content">
              
              <div v-if="ff.votesTotal > 0" class="">
              <nav class="level">
                <div class="level-item has-text-centered ">
                  <figure class="image is-128x128">
                    <chartist ratio="ct-square" type="Pie" :data="ff.chartData"></chartist>
                  </figure>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <p class="is-size-6">{{ff.up_label}}</p>
                    <p class="title is-2 thumbup">{{ff.votesUp}}</p>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <p class="is-size-6">{{ff.ok_label}}</p>
                    <p class="title is-2 thumbok">{{ff.votesOk}}</p>
                  </div>
                </div>
                <div class="level-item has-text-centered">
                  <div>
                    <p class="is-size-6">{{ff.down_label}}</p>
                    <p class="title is-2 thumbdown">{{ff.votesDown}}</p>
                  </div>
                </div>
                <div v-if="ff.option4_label" class="level-item has-text-centered">
                  <div>
                    <p class="is-size-6">{{ff.option4_label}}</p>
                    <p class="title is-2 thumboption4">{{ff.votesOption4}}</p>
                  </div>
                </div>
                <div v-if="ff.option5_label" class="level-item has-text-centered">
                  <div>
                    <p class="is-size-6">{{ff.option5_label}}</p>
                    <p class="title is-2 thumboption5">{{ff.votesOption5}}</p>
                  </div>
                </div>                
              </nav>
                <div class="is-size-7	has-text-centered">
                  Stats are different than in your ESP? <a href="/faq#stats-differ-esp-fl">Click here to learn why</a>
                </div>
              </div>
              <p v-else>
                No data yet. Please make sure you shared it with your readers.
              </p>
</div>
  <footer class="card-footer">
                        <router-link
                      class="card-footer-item"
                      :to="{ name: 'FeedbackView', params: { formId: ff.id  }}"
                      title="View Details &amp; Analytics"
                    >
                      <b-icon icon="eye" size="is-small"/>
                    </router-link>
                    <router-link v-if="ff.form_type == 'webrating'"
                      class="card-footer-item"
                      :to="{ name: 'WRFeedbackCreate', params: { copyFormId: ff.id  }}"
                      title="Copy Form"
                    >
                      <b-icon icon="copy" size="is-small"/>
                    </router-link>
                    <router-link v-if="ff.form_type == 'onetime'"
                      class="card-footer-item"
                      :to="{ name: 'OTFeedbackCreate', params: { copyFormId: ff.id  }}"
                      title="Copy Form"
                    >
                      <b-icon icon="copy" size="is-small"/>
                    </router-link>
  </footer>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import atomic from "atomicjs";

import { mapState } from 'vuex'
import {trackEvent}  from "../lib/flevents"
export default {
  name: "Dashboard",
  components: {},
  data: function () {
    return {
      feedbackForms: [],
      searchTerm: null,
      isLoading:false,
      viewMode: 0,
      sortMode: "date"
    };
  },
  mounted: function () {
    if (!this.user.isLoggedIn) {
      this.$router.push("/login");
      return
    }
    if (this.userLoaded === true) {
      this.load();
    }
    trackEvent(this.$store.state.user.id, "all-surveys-view")
  },
  computed: {
    subscribed() {
      return this.account.subscribed
    },
    ...mapState([
      "user",
      "account", "userLoaded"
    ])
  },
  watch: {
    userLoaded: function (val) {
      if (val === true) {
        console.log("user loaded")
        this.load();
      }
    }
  },
  methods: {
    load: async function () {
      var self = this;

      var url = self.apiHost + `account/${this.account.id}/feedforms`
      if( this.searchTerm !== null && this.searchTerm !== "") {
        url += "?q=" + encodeURIComponent(this.searchTerm)
      }
      //console.log(url)
      this.$store.dispatch('getAPIToken')
        .then((token) => {
          self.isLoading = true;
          atomic(url, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
              "Content-type": "application/json",
            },
          })
            .then(function (response) {
              var forms = response.data;
//console.log(forms)
              for (var i = 0; i < forms.length; i++) {
                forms[i].votesUp = forms[i].up_votes || 0
                forms[i].votesOk = forms[i].ok_votes || 0
                forms[i].votesDown = forms[i].down_votes || 0
                forms[i].votesOption4 = forms[i].option4_votes || 0
                forms[i].votesOption5 = forms[i].option5_votes || 0
                forms[i].votesTotal = forms[i].votesUp + forms[i].votesOk + forms[i].votesDown + forms[i].votesOption4 + forms[i].votesOption5
                var labels = [forms[i].up_label, forms[i].ok_label, forms[i].down_label]
                var series = [forms[i].votesUp, forms[i].votesOk, forms[i].votesDown]

                if(forms[i].option4_label !== undefined && forms[i].option4_label !== null) {
                  labels.push(forms[i].option4_label)
                  series.push(forms[i].votesOption4)
                }
                if(forms[i].option5_label !== undefined && forms[i].option5_label !== null) {
                  labels.push(forms[i].option5_label)
                  series.push(forms[i].votesOption5)
                }
                forms[i].chartData = {
                  labels: labels,
                  series: series,
                };
              }

              self.feedbackForms = forms;
              self.sortResult()
              self.isLoading = false;
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              self.isLoading = false;
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        })
        .catch((error) => {
          this.$parent.$emit("unauthed")
        });
    },
    sortResultSelect: function(event) {
      this.sortMode = event.target.value
      this.sortResult()
    },
    sortResult: function() {
      if(this.sortMode == "date") {
        this.feedbackForms.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      } else if (this.sortMode == "total") {
        this.feedbackForms.sort((a, b) => b.votesTotal - a.votesTotal);
      } else if (this.sortMode == "upvotes") {
        this.feedbackForms.sort((a, b) => b.votesUp - a.votesUp);
      } else if (this.sortMode == "okvotes") {
        this.feedbackForms.sort((a, b) => b.votesOk - a.votesOk);
      } else if (this.sortMode == "downvotes") {
        this.feedbackForms.sort((a, b) => b.votesDown - a.votesDown);
      } else if (this.sortMode == "option4votes") {
        this.feedbackForms.sort((a, b) => b.votesOption4 - a.votesOption4);
      } else if (this.sortMode == "option5votes") {
        this.feedbackForms.sort((a, b) => b.votesOption5 - a.votesOption5);
      }
    },
  },
};
</script>

<style scoped>

.no-wrap {
  white-space: nowrap;
}

</style>